import { render, staticRenderFns } from "./ApprovedVendor.vue?vue&type=template&id=eb1c90a2&scoped=true&"
import script from "./ApprovedVendor.vue?vue&type=script&lang=js&"
export * from "./ApprovedVendor.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedVendor.vue?vue&type=style&index=0&id=eb1c90a2&prod&lang=scss&scoped=true&"
import style1 from "./ApprovedVendor.vue?vue&type=style&index=1&id=eb1c90a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1c90a2",
  null
  
)

export default component.exports